export default __webpack_public_path__ + "static/Vedetta-3b5b42304c8b5f437a0d623135be43fb.jpg";